// Languages supported by bambuser-transcribe service
// for real-time (live) transcription
const CC_LOCALES_LIVE_TRANSCRIBABLE = {
  'af-ZA': 'Afrikaans',
  'ar-AE': 'العربية, الخليج (Arabic, Gulf)',
  'ar-SA': 'العربية (Arabic, Modern Standard)',
  'ast-ES': 'asturianu (Asturian)',
  'az-AZ': 'Azərbaycanca (Azerbaijani)',
  'ba-RU': 'Башҡорт теле (Bashkir)',
  'be-BY': 'беларуская мова (Belarusian)',
  'bg-BG': 'български език (Bulgarian)',
  'bn-IN': 'বাংলা (Bengali)',
  'bs-BA': 'босански (Bosnian)',
  'ca-ES': 'català (Catalan)',
  'cs-CZ': 'čeština (Czech)',
  'cy-WL': 'Cymraeg (Welsh)',
  'da-DK': 'Dansk (Danish)',
  'de-CH': 'Deutsch, Schweiz (German, Swiss)',
  'de-DE': 'Deutsch (German)',
  'el-GR': 'Ελληνικά (Greek)',
  'en-AB': 'English, Scottish',
  'en-AU': 'English, Australian',
  'en-CA': 'English, Canadian',
  'en-GB': 'English, British',
  'en-IE': 'English, Irish',
  'en-IN': 'English, Indian',
  'en-NZ': 'English, New Zealand',
  'en-US': 'English, US',
  'en-WL': 'English, Welsh',
  'en-ZA': 'English, South African',
  'es-ES': 'Español, España (Spanish, Spain)',
  'es-US': 'Español, Estados Unidos (Spanish, US)',
  'et-ET': 'eesti keel (Estonian)',
  'eu-ES': 'euskara (Basque)',
  'fa-IR': 'فارسی (Farsi)',
  'fi-FI': 'suomi (Finnish)',
  'fr-CA': 'Français, Canadien (French, Canadian)',
  'fr-FR': 'Français (French)',
  'gl-ES': 'galego (Galician)',
  'gu-IN': 'ગુજરાતી (Gujarati)',
  'ha-NG': 'Hausa (Hausa)',
  'he-IL': 'עברית (Hebrew)',
  'hi-IN': 'हिन्दी (Hindi)',
  'hr-HR': 'hrvatski (Croatian)',
  'hu-HU': 'magyar nyelv (Hungarian)',
  'hy-AM': 'հայերեն (Armenian)',
  'id-ID': 'Bahasa Indonesia (Indonesian)',
  'is-IS': 'íslenska (Icelandic)',
  'it-IT': 'Italiano (Italian)',
  'ja-JP': '日本語 (Japanese)',
  'ka-GE': 'ქართული ენა (Georgian)',
  'kk-KZ': 'қазақша (Kazakh)',
  'kn-IN': 'ಕನ್ನಡ (Kannada)',
  'ko-KR': '한국어 (Korean)',
  'lt-LT': 'lietuvių kalba (Lithuanian)',
  'lv-LV': 'latviešu valoda (Latvian)',
  'mk-MK': 'македонски јазик (Macedonian)',
  'ml-IN': 'മലയാളം (Malayalam)',
  'mn-MN': 'монгол хэл (Mongolian)',
  'mr-IN': 'मराठी (Marathi)',
  'ms-MY': 'Bahasa Melayu (Malay)',
  'mt-MT': 'Malti (Maltese)',
  'nl-NL': 'Nederlands (Dutch)',
  'no-NO': 'bokmål (Norwegian Bokmål)',
  'pa-IN': 'ਪੰਜਾਬੀ (Punjabi)',
  'pl-PL': 'język polski (Polish)',
  'ps-AF': 'پښتو ژبه (Pashto)',
  'pt-BR': 'Português, Brasil (Portuguese, Brazilian)',
  'pt-PT': 'Português (Portuguese)',
  'ro-RO': 'limba română (Romanian)',
  'ru-RU': 'Русский (Russian)',
  'si-LK': 'සිංහල (Sinhala)',
  'sk-SK': 'slovenský (Slovak)',
  'sl-SI': 'slovenščina (Slovenian)',
  'so-SO': 'Af Soomaali (Somali)',
  'sr-RS': 'српски језик (Serbian)',
  'su-ID': 'basa Sunda (Sudanese)',
  'sv-SE': 'Svenska (Swedish)',
  'sw-BI': 'Kiswahili, Burundi (Swahili, Burundi)',
  'sw-KE': 'Kiswahili, Kenya (Swahili, Kenya)',
  'sw-RW': 'Kiswahili, Rwanda (Swahili, Rwanda)',
  'sw-TZ': 'Kiswahili, Tanzania (Swahili, Tanzania)',
  'sw-UG': 'Kiswahili, Uganda (Swahili, Uganda)',
  'ta-IN': 'தமிழ் (Tamil)',
  'te-IN': 'తెలుగు (Telugu)',
  'th-TH': 'ภาษาไทย (Thai)',
  'tl-PH': 'Wikang Tagalog/Filipino (Tagalog/Filipino)',
  'tr-TR': 'Türkçe (Turkish)',
  'tt-RU': 'татар теле (Tatar)',
  'uk-UA': 'українська мова (Ukrainian)',
  'uz-UZ': 'O\u02BBzbek tili / ўзбек тили (Uzbek)',
  'vi-VN': 'Tiếng Việt (Vietnamese)',
  'wo-SN': 'Wolof làkk (Wolof)',
  'zh-CN': '中文, 简体 (Chinese, Simplified)',
  'zh-TW': '中文, 繁體 (Chinese, Traditional)',
  'zu-ZA': 'isiZulu (Zulu)',
};

const DEFAULT_CC_LIVE_TRANSCRIBABLE = 'en-US';

// Languages supported by bambuser-transcribe service
// for async (pre-recorded and archived) transcription
const CC_LOCALES = {
  'ab-GE': 'Аԥсшәа (Abkhazian)',
  'af-ZA': 'Afrikaans',
  'ar-AE': 'العربية, الخليج (Arabic, Gulf)',
  'ar-SA': 'العربية (Arabic, Modern Standard)',
  'ast-ES': 'asturianu (Asturian)',
  'az-AZ': 'Azərbaycanca (Azerbaijani)',
  'ba-RU': 'Башҡорт теле (Bashkir)',
  'be-BY': 'беларуская мова (Belarusian)',
  'bg-BG': 'български език (Bulgarian)',
  'bn-IN': 'বাংলা (Bengali)',
  'bs-BA': 'босански (Bosnian)',
  'ca-ES': 'català (Catalan)',
  'ckb-IQ': 'کوردیی ناوەندی، عێراق (Central Kurdish, Iraq)',
  'ckb-IR': 'کوردیی ناوەندی، ئێران (Central Kurdish, Iran)',
  'cs-CZ': 'čeština (Czech)',
  'cy-WL': 'Cymraeg (Welsh)',
  'da-DK': 'Dansk (Danish)',
  'de-CH': 'Deutsch, Schweiz (German, Swiss)',
  'de-DE': 'Deutsch (German)',
  'el-GR': 'Ελληνικά (Greek)',
  'en-AB': 'English, Scottish',
  'en-AU': 'English, Australian',
  'en-CA': 'English, Canadian',
  'en-GB': 'English, British',
  'en-IE': 'English, Irish',
  'en-IN': 'English, Indian',
  'en-NZ': 'English, New Zealand',
  'en-US': 'English, US',
  'en-WL': 'English, Welsh',
  'en-ZA': 'English, South African',
  'es-ES': 'Español, España (Spanish, Spain)',
  'es-US': 'Español, Estados Unidos (Spanish, US)',
  'et-ET': 'eesti keel (Estonian)',
  'eu-ES': 'euskara (Basque)',
  'fa-IR': 'فارسی (Farsi)',
  'fi-FI': 'suomi (Finnish)',
  'fr-CA': 'Français, Canadien (French, Canadian)',
  'fr-FR': 'Français (French)',
  'gl-ES': 'galego (Galician)',
  'gu-IN': 'ગુજરાતી (Gujarati)',
  'ha-NG': 'Hausa (Hausa)',
  'he-IL': 'עברית (Hebrew)',
  'hi-IN': 'हिन्दी (Hindi)',
  'hr-HR': 'hrvatski (Croatian)',
  'hu-HU': 'magyar nyelv (Hungarian)',
  'hy-AM': 'հայերեն (Armenian)',
  'id-ID': 'Bahasa Indonesia (Indonesian)',
  'is-IS': 'íslenska (Icelandic)',
  'it-IT': 'Italiano (Italian)',
  'ja-JP': '日本語 (Japanese)',
  'ka-GE': 'ქართული ენა (Georgian)',
  'kab-DZ': 'Taqbaylit (Kabyle)',
  'kk-KZ': 'қазақша (Kazakh)',
  'kn-IN': 'ಕನ್ನಡ (Kannada)',
  'ko-KR': '한국어 (Korean)',
  'ky-KG': 'Кыргыз тили (Kyrgyz)',
  'lg-IN': 'Oluganda (Luganda)',
  'lt-LT': 'lietuvių kalba (Lithuanian)',
  'lv-LV': 'latviešu valoda (Latvian)',
  'mhr-RU': 'олык марий йылме (Eastern/Meadow Mari)',
  'mk-MK': 'македонски јазик (Macedonian)',
  'ml-IN': 'മലയാളം (Malayalam)',
  'mn-MN': 'монгол хэл (Mongolian)',
  'mr-IN': 'मराठी (Marathi)',
  'ms-MY': 'Bahasa Melayu (Malay)',
  'mt-MT': 'Malti (Maltese)',
  'nl-NL': 'Nederlands (Dutch)',
  'no-NO': 'bokmål (Norwegian Bokmål)',
  'or-IN': 'ଓଡ଼ିଆ (Odia)',
  'pa-IN': 'ਪੰਜਾਬੀ (Punjabi)',
  'pl-PL': 'język polski (Polish)',
  'ps-AF': 'پښتو ژبه (Pashto)',
  'pt-BR': 'Português, Brasil (Portuguese, Brazilian)',
  'pt-PT': 'Português (Portuguese)',
  'ro-RO': 'limba română (Romanian)',
  'ru-RU': 'Русский (Russian)',
  'rw-RW': 'Ikinyarwanda (Kinyarwanda)',
  'si-LK': 'සිංහල (Sinhala)',
  'sk-SK': 'slovenský (Slovak)',
  'sl-SI': 'slovenščina (Slovenian)',
  'so-SO': 'Af Soomaali (Somali)',
  'sr-RS': 'српски језик (Serbian)',
  'su-ID': 'basa Sunda (Sudanese)',
  'sv-SE': 'Svenska (Swedish)',
  'sw-BI': 'Kiswahili, Burundi (Swahili, Burundi)',
  'sw-KE': 'Kiswahili, Kenya (Swahili, Kenya)',
  'sw-RW': 'Kiswahili, Rwanda (Swahili, Rwanda)',
  'sw-TZ': 'Kiswahili, Tanzania (Swahili, Tanzania)',
  'sw-UG': 'Kiswahili, Uganda (Swahili, Uganda)',
  'ta-IN': 'தமிழ் (Tamil)',
  'te-IN': 'తెలుగు (Telugu)',
  'th-TH': 'ภาษาไทย (Thai)',
  'tl-PH': 'Wikang Tagalog/Filipino (Tagalog/Filipino)',
  'tr-TR': 'Türkçe (Turkish)',
  'tt-RU': 'татар теле (Tatar)',
  'ug-CN': 'ئۇيغۇر تىلى (Uyghur)',
  'uk-UA': 'українська мова (Ukrainian)',
  'uz-UZ': 'O\u02BBzbek tili / ўзбек тили (Uzbek)',
  'vi-VN': 'Tiếng Việt (Vietnamese)',
  'wo-SN': 'Wolof làkk (Wolof)',
  'zh-CN': '中文, 简体 (Chinese, Simplified)',
  'zh-TW': '中文, 繁體 (Chinese, Traditional)',
  'zu-ZA': 'isiZulu (Zulu)',
};

const LANGUAGE_BY_LOCALE = {
  'af-NA': 'Afrikaans (Namibia)',
  'af-ZA': 'Afrikaans (South Africa)',
  af: 'Afrikaans',
  'ak-GH': 'Akan (Ghana)',
  ak: 'Akan',
  'sq-AL': 'Albanian (Albania)',
  sq: 'Albanian',
  'am-ET': 'Amharic (Ethiopia)',
  am: 'Amharic',
  'ar-DZ': 'Arabic (Algeria)',
  'ar-BH': 'Arabic (Bahrain)',
  'ar-EG': 'Arabic (Egypt)',
  'ar-IQ': 'Arabic (Iraq)',
  'ar-JO': 'Arabic (Jordan)',
  'ar-KW': 'Arabic (Kuwait)',
  'ar-LB': 'Arabic (Lebanon)',
  'ar-LY': 'Arabic (Libya)',
  'ar-MA': 'Arabic (Morocco)',
  'ar-OM': 'Arabic (Oman)',
  'ar-QA': 'Arabic (Qatar)',
  'ar-SA': 'Arabic (Saudi Arabia)',
  'ar-SD': 'Arabic (Sudan)',
  'ar-SY': 'Arabic (Syria)',
  'ar-TN': 'Arabic (Tunisia)',
  'ar-AE': 'Arabic (United Arab Emirates)',
  'ar-YE': 'Arabic (Yemen)',
  ar: 'Arabic',
  'hy-AM': 'Armenian (Armenia)',
  hy: 'Armenian',
  'as-IN': 'Assamese (India)',
  as: 'Assamese',
  'asa-TZ': 'Asu (Tanzania)',
  asa: 'Asu',
  'az-Cyrl': 'Azerbaijani (Cyrillic)',
  'az-Cyrl-AZ': 'Azerbaijani (Cyrillic, Azerbaijan)',
  'az-Latn': 'Azerbaijani (Latin)',
  'az-Latn-AZ': 'Azerbaijani (Latin, Azerbaijan)',
  az: 'Azerbaijani',
  'bm-ML': 'Bambara (Mali)',
  bm: 'Bambara',
  'eu-ES': 'Basque (Spain)',
  eu: 'Basque',
  'be-BY': 'Belarusian (Belarus)',
  be: 'Belarusian',
  'bem-ZM': 'Bemba (Zambia)',
  bem: 'Bemba',
  'bez-TZ': 'Bena (Tanzania)',
  bez: 'Bena',
  'bn-BD': 'Bengali (Bangladesh)',
  'bn-IN': 'Bengali (India)',
  bn: 'Bengali',
  'bs-BA': 'Bosnian (Bosnia and Herzegovina)',
  bs: 'Bosnian',
  'bg-BG': 'Bulgarian (Bulgaria)',
  bg: 'Bulgarian',
  'my-MM': 'Burmese (Myanmar [Burma])',
  my: 'Burmese',
  'yue-Hant-HK': 'Cantonese (Traditional, Hong Kong SAR China)',
  'ca-ES': 'Catalan (Spain)',
  ca: 'Catalan',
  'tzm-Latn': 'Central Morocco Tamazight (Latin)',
  'tzm-Latn-MA': 'Central Morocco Tamazight (Latin, Morocco)',
  tzm: 'Central Morocco Tamazight',
  'chr-US': 'Cherokee (United States)',
  chr: 'Cherokee',
  'cgg-UG': 'Chiga (Uganda)',
  cgg: 'Chiga',
  'zh-Hans': 'Chinese (Simplified Han)',
  'zh-Hans-CN': 'Chinese (Simplified Han, China)',
  'zh-Hans-HK': 'Chinese (Simplified Han, Hong Kong SAR China)',
  'zh-Hans-MO': 'Chinese (Simplified Han, Macau SAR China)',
  'zh-Hans-SG': 'Chinese (Simplified Han, Singapore)',
  'zh-Hant': 'Chinese (Traditional Han)',
  'zh-Hant-HK': 'Chinese (Traditional Han, Hong Kong SAR China)',
  'zh-Hant-MO': 'Chinese (Traditional Han, Macau SAR China)',
  'zh-Hant-TW': 'Chinese (Traditional Han, Taiwan)',
  zh: 'Chinese',
  'kw-GB': 'Cornish (United Kingdom)',
  kw: 'Cornish',
  'hr-HR': 'Croatian (Croatia)',
  hr: 'Croatian',
  'cs-CZ': 'Czech (Czech Republic)',
  cs: 'Czech',
  'da-DK': 'Danish (Denmark)',
  da: 'Danish',
  'nl-BE': 'Dutch (Belgium)',
  'nl-NL': 'Dutch (Netherlands)',
  nl: 'Dutch',
  'ebu-KE': 'Embu (Kenya)',
  ebu: 'Embu',
  'en-AS': 'English (American Samoa)',
  'en-AU': 'English (Australia)',
  'en-BE': 'English (Belgium)',
  'en-BZ': 'English (Belize)',
  'en-BW': 'English (Botswana)',
  'en-CA': 'English (Canada)',
  'en-GU': 'English (Guam)',
  'en-HK': 'English (Hong Kong SAR China)',
  'en-IN': 'English (India)',
  'en-IE': 'English (Ireland)',
  'en-IL': 'English (Israel)',
  'en-JM': 'English (Jamaica)',
  'en-MT': 'English (Malta)',
  'en-MH': 'English (Marshall Islands)',
  'en-MU': 'English (Mauritius)',
  'en-NA': 'English (Namibia)',
  'en-NZ': 'English (New Zealand)',
  'en-MP': 'English (Northern Mariana Islands)',
  'en-PK': 'English (Pakistan)',
  'en-PH': 'English (Philippines)',
  'en-SG': 'English (Singapore)',
  'en-ZA': 'English (South Africa)',
  'en-TT': 'English (Trinidad and Tobago)',
  'en-UM': 'English (U.S. Minor Outlying Islands)',
  'en-VI': 'English (U.S. Virgin Islands)',
  'en-GB': 'English (United Kingdom)',
  'en-US': 'English (United States)',
  'en-ZW': 'English (Zimbabwe)',
  en: 'English',
  eo: 'Esperanto',
  'et-EE': 'Estonian (Estonia)',
  et: 'Estonian',
  'ee-GH': 'Ewe (Ghana)',
  'ee-TG': 'Ewe (Togo)',
  ee: 'Ewe',
  'fo-FO': 'Faroese (Faroe Islands)',
  fo: 'Faroese',
  'fil-PH': 'Filipino (Philippines)',
  fil: 'Filipino',
  'fi-FI': 'Finnish (Finland)',
  fi: 'Finnish',
  'fr-BE': 'French (Belgium)',
  'fr-BJ': 'French (Benin)',
  'fr-BF': 'French (Burkina Faso)',
  'fr-BI': 'French (Burundi)',
  'fr-CM': 'French (Cameroon)',
  'fr-CA': 'French (Canada)',
  'fr-CF': 'French (Central African Republic)',
  'fr-TD': 'French (Chad)',
  'fr-KM': 'French (Comoros)',
  'fr-CG': 'French (Congo - Brazzaville)',
  'fr-CD': 'French (Congo - Kinshasa)',
  'fr-CI': 'French (Côte d’Ivoire)',
  'fr-DJ': 'French (Djibouti)',
  'fr-GQ': 'French (Equatorial Guinea)',
  'fr-FR': 'French (France)',
  'fr-GA': 'French (Gabon)',
  'fr-GP': 'French (Guadeloupe)',
  'fr-GN': 'French (Guinea)',
  'fr-LU': 'French (Luxembourg)',
  'fr-MG': 'French (Madagascar)',
  'fr-ML': 'French (Mali)',
  'fr-MQ': 'French (Martinique)',
  'fr-MC': 'French (Monaco)',
  'fr-NE': 'French (Niger)',
  'fr-RW': 'French (Rwanda)',
  'fr-RE': 'French (Réunion)',
  'fr-BL': 'French (Saint Barthélemy)',
  'fr-MF': 'French (Saint Martin)',
  'fr-SN': 'French (Senegal)',
  'fr-CH': 'French (Switzerland)',
  'fr-TG': 'French (Togo)',
  fr: 'French',
  'ff-SN': 'Fulah (Senegal)',
  ff: 'Fulah',
  'gl-ES': 'Galician (Spain)',
  gl: 'Galician',
  'lg-UG': 'Ganda (Uganda)',
  lg: 'Ganda',
  'ka-GE': 'Georgian (Georgia)',
  ka: 'Georgian',
  'de-AT': 'German (Austria)',
  'de-BE': 'German (Belgium)',
  'de-DE': 'German (Germany)',
  'de-LI': 'German (Liechtenstein)',
  'de-LU': 'German (Luxembourg)',
  'de-CH': 'German (Switzerland)',
  de: 'German',
  'el-CY': 'Greek (Cyprus)',
  'el-GR': 'Greek (Greece)',
  el: 'Greek',
  'gu-IN': 'Gujarati (India)',
  gu: 'Gujarati',
  'guz-KE': 'Gusii (Kenya)',
  guz: 'Gusii',
  'ha-Latn': 'Hausa (Latin)',
  'ha-Latn-GH': 'Hausa (Latin, Ghana)',
  'ha-Latn-NE': 'Hausa (Latin, Niger)',
  'ha-Latn-NG': 'Hausa (Latin, Nigeria)',
  ha: 'Hausa',
  'haw-US': 'Hawaiian (United States)',
  haw: 'Hawaiian',
  'he-IL': 'Hebrew (Israel)',
  he: 'Hebrew',
  'hi-IN': 'Hindi (India)',
  hi: 'Hindi',
  'hu-HU': 'Hungarian (Hungary)',
  hu: 'Hungarian',
  'is-IS': 'Icelandic (Iceland)',
  is: 'Icelandic',
  'ig-NG': 'Igbo (Nigeria)',
  ig: 'Igbo',
  'id-ID': 'Indonesian (Indonesia)',
  id: 'Indonesian',
  'ga-IE': 'Irish (Ireland)',
  ga: 'Irish',
  'it-IT': 'Italian (Italy)',
  'it-CH': 'Italian (Switzerland)',
  it: 'Italian',
  'ja-JP': 'Japanese (Japan)',
  ja: 'Japanese',
  'kea-CV': 'Kabuverdianu (Cape Verde)',
  kea: 'Kabuverdianu',
  'kab-DZ': 'Kabyle (Algeria)',
  kab: 'Kabyle',
  'kl-GL': 'Kalaallisut (Greenland)',
  kl: 'Kalaallisut',
  'kln-KE': 'Kalenjin (Kenya)',
  kln: 'Kalenjin',
  'kam-KE': 'Kamba (Kenya)',
  kam: 'Kamba',
  'kn-IN': 'Kannada (India)',
  kn: 'Kannada',
  'kk-Cyrl': 'Kazakh (Cyrillic)',
  'kk-Cyrl-KZ': 'Kazakh (Cyrillic, Kazakhstan)',
  kk: 'Kazakh',
  'km-KH': 'Khmer (Cambodia)',
  km: 'Khmer',
  'ki-KE': 'Kikuyu (Kenya)',
  ki: 'Kikuyu',
  'rw-RW': 'Kinyarwanda (Rwanda)',
  rw: 'Kinyarwanda',
  'kok-IN': 'Konkani (India)',
  kok: 'Konkani',
  'ko-KR': 'Korean (South Korea)',
  ko: 'Korean',
  'khq-ML': 'Koyra Chiini (Mali)',
  khq: 'Koyra Chiini',
  'ses-ML': 'Koyraboro Senni (Mali)',
  ses: 'Koyraboro Senni',
  'lag-TZ': 'Langi (Tanzania)',
  lag: 'Langi',
  'lv-LV': 'Latvian (Latvia)',
  lv: 'Latvian',
  'lt-LT': 'Lithuanian (Lithuania)',
  lt: 'Lithuanian',
  'luo-KE': 'Luo (Kenya)',
  luo: 'Luo',
  'luy-KE': 'Luyia (Kenya)',
  luy: 'Luyia',
  'mk-MK': 'Macedonian (Macedonia)',
  mk: 'Macedonian',
  'jmc-TZ': 'Machame (Tanzania)',
  jmc: 'Machame',
  'kde-TZ': 'Makonde (Tanzania)',
  kde: 'Makonde',
  'mg-MG': 'Malagasy (Madagascar)',
  mg: 'Malagasy',
  'ms-BN': 'Malay (Brunei)',
  'ms-MY': 'Malay (Malaysia)',
  ms: 'Malay',
  'ml-IN': 'Malayalam (India)',
  ml: 'Malayalam',
  'mt-MT': 'Maltese (Malta)',
  mt: 'Maltese',
  'gv-GB': 'Manx (United Kingdom)',
  gv: 'Manx',
  'mr-IN': 'Marathi (India)',
  mr: 'Marathi',
  'mas-KE': 'Masai (Kenya)',
  'mas-TZ': 'Masai (Tanzania)',
  mas: 'Masai',
  'mer-KE': 'Meru (Kenya)',
  mer: 'Meru',
  'mfe-MU': 'Morisyen (Mauritius)',
  mfe: 'Morisyen',
  'naq-NA': 'Nama (Namibia)',
  naq: 'Nama',
  'ne-IN': 'Nepali (India)',
  'ne-NP': 'Nepali (Nepal)',
  ne: 'Nepali',
  'nd-ZW': 'North Ndebele (Zimbabwe)',
  nd: 'North Ndebele',
  no: 'Norwegian',
  'nb-NO': 'Norwegian Bokmål (Norway)',
  nb: 'Norwegian Bokmål',
  'nn-NO': 'Norwegian Nynorsk (Norway)',
  nn: 'Norwegian Nynorsk',
  'nyn-UG': 'Nyankole (Uganda)',
  nyn: 'Nyankole',
  'or-IN': 'Oriya (India)',
  or: 'Oriya',
  'om-ET': 'Oromo (Ethiopia)',
  'om-KE': 'Oromo (Kenya)',
  om: 'Oromo',
  'ps-AF': 'Pashto (Afghanistan)',
  ps: 'Pashto',
  'fa-AF': 'Persian (Afghanistan)',
  'fa-IR': 'Persian (Iran)',
  fa: 'Persian',
  'pl-PL': 'Polish (Poland)',
  pl: 'Polish',
  'pt-BR': 'Portuguese (Brazil)',
  'pt-GW': 'Portuguese (Guinea-Bissau)',
  'pt-MZ': 'Portuguese (Mozambique)',
  'pt-PT': 'Portuguese (Portugal)',
  pt: 'Portuguese',
  'pa-Arab': 'Punjabi (Arabic)',
  'pa-Arab-PK': 'Punjabi (Arabic, Pakistan)',
  'pa-Guru': 'Punjabi (Gurmukhi)',
  'pa-Guru-IN': 'Punjabi (Gurmukhi, India)',
  pa: 'Punjabi',
  'ro-MD': 'Romanian (Moldova)',
  'ro-RO': 'Romanian (Romania)',
  ro: 'Romanian',
  'rm-CH': 'Romansh (Switzerland)',
  rm: 'Romansh',
  'rof-TZ': 'Rombo (Tanzania)',
  rof: 'Rombo',
  'ru-MD': 'Russian (Moldova)',
  'ru-RU': 'Russian (Russia)',
  'ru-UA': 'Russian (Ukraine)',
  ru: 'Russian',
  'rwk-TZ': 'Rwa (Tanzania)',
  rwk: 'Rwa',
  'saq-KE': 'Samburu (Kenya)',
  saq: 'Samburu',
  'sg-CF': 'Sango (Central African Republic)',
  sg: 'Sango',
  'seh-MZ': 'Sena (Mozambique)',
  seh: 'Sena',
  'sr-Cyrl': 'Serbian (Cyrillic)',
  'sr-Cyrl-BA': 'Serbian (Cyrillic, Bosnia and Herzegovina)',
  'sr-Cyrl-ME': 'Serbian (Cyrillic, Montenegro)',
  'sr-Cyrl-RS': 'Serbian (Cyrillic, Serbia)',
  'sr-Latn': 'Serbian (Latin)',
  'sr-Latn-BA': 'Serbian (Latin, Bosnia and Herzegovina)',
  'sr-Latn-ME': 'Serbian (Latin, Montenegro)',
  'sr-Latn-RS': 'Serbian (Latin, Serbia)',
  sr: 'Serbian',
  'sn-ZW': 'Shona (Zimbabwe)',
  sn: 'Shona',
  'ii-CN': 'Sichuan Yi (China)',
  ii: 'Sichuan Yi',
  'si-LK': 'Sinhala (Sri Lanka)',
  si: 'Sinhala',
  'sk-SK': 'Slovak (Slovakia)',
  sk: 'Slovak',
  'sl-SI': 'Slovenian (Slovenia)',
  sl: 'Slovenian',
  'xog-UG': 'Soga (Uganda)',
  xog: 'Soga',
  'so-DJ': 'Somali (Djibouti)',
  'so-ET': 'Somali (Ethiopia)',
  'so-KE': 'Somali (Kenya)',
  'so-SO': 'Somali (Somalia)',
  so: 'Somali',
  'es-AR': 'Spanish (Argentina)',
  'es-BO': 'Spanish (Bolivia)',
  'es-CL': 'Spanish (Chile)',
  'es-CO': 'Spanish (Colombia)',
  'es-CR': 'Spanish (Costa Rica)',
  'es-DO': 'Spanish (Dominican Republic)',
  'es-EC': 'Spanish (Ecuador)',
  'es-SV': 'Spanish (El Salvador)',
  'es-GQ': 'Spanish (Equatorial Guinea)',
  'es-GT': 'Spanish (Guatemala)',
  'es-HN': 'Spanish (Honduras)',
  'es-419': 'Spanish (Latin America)',
  'es-MX': 'Spanish (Mexico)',
  'es-NI': 'Spanish (Nicaragua)',
  'es-PA': 'Spanish (Panama)',
  'es-PY': 'Spanish (Paraguay)',
  'es-PE': 'Spanish (Peru)',
  'es-PR': 'Spanish (Puerto Rico)',
  'es-ES': 'Spanish (Spain)',
  'es-US': 'Spanish (United States)',
  'es-UY': 'Spanish (Uruguay)',
  'es-VE': 'Spanish (Venezuela)',
  es: 'Spanish',
  'sw-KE': 'Swahili (Kenya)',
  'sw-TZ': 'Swahili (Tanzania)',
  sw: 'Swahili',
  'sv-FI': 'Swedish (Finland)',
  'sv-SE': 'Swedish (Sweden)',
  sv: 'Swedish',
  'gsw-CH': 'Swiss German (Switzerland)',
  gsw: 'Swiss German',
  'shi-Latn': 'Tachelhit (Latin)',
  'shi-Latn-MA': 'Tachelhit (Latin, Morocco)',
  'shi-Tfng': 'Tachelhit (Tifinagh)',
  'shi-Tfng-MA': 'Tachelhit (Tifinagh, Morocco)',
  shi: 'Tachelhit',
  'dav-KE': 'Taita (Kenya)',
  dav: 'Taita',
  'ta-IN': 'Tamil (India)',
  'ta-LK': 'Tamil (Sri Lanka)',
  ta: 'Tamil',
  'te-IN': 'Telugu (India)',
  te: 'Telugu',
  'teo-KE': 'Teso (Kenya)',
  'teo-UG': 'Teso (Uganda)',
  teo: 'Teso',
  'th-TH': 'Thai (Thailand)',
  th: 'Thai',
  'bo-CN': 'Tibetan (China)',
  'bo-IN': 'Tibetan (India)',
  bo: 'Tibetan',
  'ti-ER': 'Tigrinya (Eritrea)',
  'ti-ET': 'Tigrinya (Ethiopia)',
  ti: 'Tigrinya',
  'to-TO': 'Tonga (Tonga)',
  to: 'Tonga',
  'tr-TR': 'Turkish (Turkey)',
  tr: 'Turkish',
  'uk-UA': 'Ukrainian (Ukraine)',
  uk: 'Ukrainian',
  'ur-IN': 'Urdu (India)',
  'ur-PK': 'Urdu (Pakistan)',
  ur: 'Urdu',
  'uz-Arab': 'Uzbek (Arabic)',
  'uz-Arab-AF': 'Uzbek (Arabic, Afghanistan)',
  'uz-Cyrl': 'Uzbek (Cyrillic)',
  'uz-Cyrl-UZ': 'Uzbek (Cyrillic, Uzbekistan)',
  'uz-Latn': 'Uzbek (Latin)',
  'uz-Latn-UZ': 'Uzbek (Latin, Uzbekistan)',
  uz: 'Uzbek',
  'vi-VN': 'Vietnamese (Vietnam)',
  vi: 'Vietnamese',
  'vun-TZ': 'Vunjo (Tanzania)',
  vun: 'Vunjo',
  'cy-GB': 'Welsh (United Kingdom)',
  cy: 'Welsh',
  'yo-NG': 'Yoruba (Nigeria)',
  yo: 'Yoruba',
  'zu-ZA': 'Zulu (South Africa)',
  zu: 'Zulu',
};

// Based on http://www.lingoes.net/en/translator/langcode.htm
const SHORT_CODE_TO_LOCALE = {
  af: 'af-ZA',
  ar: 'ar-AE',
  az: 'az-AZ',
  be: 'be-BY',
  bg: 'bg-BG',
  bs: 'bs-BA',
  ca: 'ca-ES',
  cs: 'cs-CZ',
  cy: 'cy-GB',
  de: 'de-DE',
  dv: 'dv-MV',
  el: 'el-GR',
  en: 'en-US',
  es: 'es-ES',
  et: 'et-EE',
  eu: 'eu-ES',
  fa: 'fa-IR',
  fi: 'fi-FI',
  fo: 'fo-FO',
  fr: 'fr-FR',
  gl: 'gl-ES',
  gu: 'gu-IN',
  he: 'he-IL',
  hi: 'hi-IN',
  hr: 'hr-HR',
  hu: 'hu-HU',
  hy: 'hy-AM',
  id: 'id-ID',
  is: 'is-IS',
  it: 'it-IT',
  ja: 'ja-JP',
  ka: 'ka-GE',
  kk: 'k-KZ',
  kn: 'kn-IN',
  ko: 'ko-KR',
  kok: 'kok-IN',
  ky: 'ky-KG',
  lt: 'lt-LT',
  lv: 'lv-LV',
  mi: 'mi-NZ',
  mk: 'mk-MK',
  mn: 'mn-MN',
  mr: 'mr-IN',
  ms: 'ms-MY',
  mt: 'mt-MT',
  nb: 'nb-NO',
  nl: 'nl-NL',
  nn: 'nn-NO',
  ns: 'ns-ZA',
  pa: 'pa-IN',
  pl: 'pl-PL',
  ps: 'ps-AR',
  pt: 'pt-PT',
  qu: 'qu-PE',
  ro: 'ro-RO',
  ru: 'ru-RU',
  sa: 'sa-IN',
  sk: 'sk-SK',
  sl: 'sl-SI',
  sq: 'sq-AL',
  sr: 'sr-SP',
  sv: 'sv-SE',
  sw: 'sw-KE',
  syr: 'syr-SY',
  ta: 'ta-IN',
  te: 'te-IN',
  th: 'th-TH',
  tl: 'tl-PH',
  tn: 'tn-ZA',
  tr: 'tr-TR',
  tt: 'tt-RU',
  uk: 'uk-UA',
  ur: 'ur-PK',
  uz: 'uz-UZ',
  vi: 'vi-VN',
  xh: 'xh-ZA',
  zh: 'zh-CN',
};

const SUBTITLES_LANGUAGES = {
  'ar-SA': { language: 'العربية (Arabic, Modern Standard)', locale: 'ar-SA', beta: true },
  'bg-BG': { language: 'български език (Bulgarian)', locale: 'bg-BG' },
  'bs-BA': { language: 'босански (Bosnian)', locale: 'bs-BA' },
  'ca-ES': { language: 'català (Catalan)', locale: 'ca-ES' },
  'cs-CZ': { language: 'čeština (Czech)', locale: 'cs-CZ' },
  'da-DK': { language: 'Dansk (Danish)', locale: 'da-DK' },
  'de-DE': { language: 'Deutsch (German)', locale: 'de-DE' },
  'el-GR': { language: 'Ελληνικά (Greek)', locale: 'el-GR' },
  'en-US': { language: 'English, US', locale: 'en-US' },
  'es-US': { language: 'Español, Estados Unidos (Spanish, US)', locale: 'es-US' },
  'et-ET': { language: 'eesti keel (Estonian)', locale: 'et-ET' },
  'fi-FI': { language: 'suomi (Finnish)', locale: 'fi-FI' },
  'fr-FR': { language: 'Français (French)', locale: 'fr-FR' },
  'gl-ES': { language: 'galego (Galician)', locale: 'gl-ES' },
  'he-IL': { language: 'עברית (Hebrew)', locale: 'he-IL', beta: true },
  'hi-IN': { language: 'हिन्दी (Hindi)', locale: 'hi-IN', beta: true },
  'hr-HR': { language: 'hrvatski (Croatian)', locale: 'hr-HR' },
  'hu-HU': { language: 'magyar nyelv (Hungarian)', locale: 'hu-HU' },
  'id-ID': { language: 'Bahasa Indonesia (Indonesian)', locale: 'id-ID' },
  'is-IS': { language: 'íslenska (Icelandic)', locale: 'is-IS', beta: true },
  'it-IT': { language: 'Italiano (Italian)', locale: 'it-IT' },
  'ja-JP': { language: '日本語 (Japanese)', locale: 'ja-JP', beta: true },
  'ko-KR': { language: '한국어 (Korean)', locale: 'ko-KR', beta: true },
  'lv-LV': { language: 'latviešu valoda (Latvian)', locale: 'lv-LV' },
  'mk-MK': { language: 'македонски јазик (Macedonian)', locale: 'mk-MK' },
  'ms-MY': { language: 'Bahasa Melayu (Malay)', locale: 'ms-MY' },
  'nl-NL': { language: 'Nederlands (Dutch)', locale: 'nl-NL' },
  'no-NO': { language: 'bokmål (Norwegian Bokmål)', locale: 'no-NO' },
  'pl-PL': { language: 'język polski (Polish)', locale: 'pl-PL' },
  'pt-BR': { language: 'Português, Brasil (Portuguese, Brazilian)', locale: 'pt-BR' },
  'ro-RO': { language: 'limba română (Romanian)', locale: 'ro-RO' },
  'ru-RU': { language: 'Русский (Russian)', locale: 'ru-RU' },
  'sk-SK': { language: 'slovenský (Slovak)', locale: 'sk-SK' },
  'sl-SI': { language: 'slovenščina (Slovenian)', locale: 'sl-SI' },
  'sr-RS': { language: 'српски језик (Serbian)', locale: 'sr-RS' },
  'sv-SE': { language: 'Svenska (Swedish)', locale: 'sv-SE' },
  'th-TH': { language: 'ภาษาไทย (Thai)', locale: 'th-TH' },
  'tl-PH': { language: 'Wikang Tagalog/Filipino (Tagalog/Filipino)', locale: 'tl-PH', beta: true },
  'tr-TR': { language: 'Türkçe (Turkish)', locale: 'tr-TR' },
  'uk-UA': { language: 'українська мова (Ukrainian)', locale: 'uk-UA' },
  'vi-VN': { language: 'Tiếng Việt (Vietnamese)', locale: 'vi-VN' },
  'zh-CN': { language: '中文, 简体 (Chinese, Simplified)', locale: 'zh-CN', beta: true },
};

// source: https://stackoverflow.com/a/28357857
export default LANGUAGE_BY_LOCALE;

export {
  CC_LOCALES_LIVE_TRANSCRIBABLE,
  CC_LOCALES,
  DEFAULT_CC_LIVE_TRANSCRIBABLE,
  SHORT_CODE_TO_LOCALE,
  SUBTITLES_LANGUAGES,
};
